import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProfileButton: React.FC = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  return (
    <button
      onClick={() => navigate('/profile')}
      className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors flex-shrink-0 ${
        isAuthenticated
          ? 'bg-gradient-to-br from-orange-400 to-red-400 hover:from-orange-500 hover:to-red-500'
          : 'bg-gray-100 hover:bg-gray-200'
      }`}
      title="Профиль"
    >
      {isAuthenticated && user ? (
        <span className="text-white text-xs font-bold">
          {(user.name || user.email || '?')[0].toUpperCase()}
        </span>
      ) : (
        <svg className="w-4 h-4 text-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
        </svg>
      )}
    </button>
  );
};

export default ProfileButton;
